<mat-toolbar color="primary">Fee Schedule Cleanup</mat-toolbar>

<mat-dialog-content class="min-h-[300px]">
  <div class="flex items-center justify-between border-b px-4 py-3">
    <div class="flex items-center gap-2">
      <mat-icon fontSet="material-symbols-outlined">toggle_on</mat-icon>
      <span class="text-sm font-medium">Practice & Staffer Fee Schedules</span>
    </div>
    <mat-slide-toggle
      [checked]="featureEnabled()"
      (change)="toggleFeatureFlag()"
      aria-label="Toggle practice and staffer fee schedules"
    />
  </div>

  @if (loading$ | async) {
    <div
      class="flex flex-col items-center justify-center px-4 py-8 text-black/60"
    >
      <mat-spinner diameter="40" />
      <p class="mt-4 text-sm">Loading fee schedules...</p>
    </div>
  } @else if ((feeScheduleRows$ | async)?.length) {
    <table mat-table [dataSource]="(feeScheduleRows$ | async) ?? []">
      <ng-container matColumnDef="parentType">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let row">
          <span
            class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
            [ngClass]="{
              'bg-blue-100 text-blue-800': row.parentType === 'Practice',
              'bg-purple-100 text-purple-800': row.parentType === 'Staffer'
            }"
          >
            {{ row.parentType }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="parentName">
        <th mat-header-cell *matHeaderCellDef>Owner</th>
        <td mat-cell *matCellDef="let row">{{ row.parentName }}</td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Schedule</th>
        <td mat-cell *matCellDef="let row">{{ row.feeSchedule.name }}</td>
      </ng-container>

      <ng-container matColumnDef="serviceCodes">
        <th mat-header-cell *matHeaderCellDef>Service Codes</th>
        <td mat-cell *matCellDef="let row">{{ row.serviceCodeCount }}</td>
      </ng-container>

      <ng-container matColumnDef="treatmentFees">
        <th mat-header-cell *matHeaderCellDef>Treatment Fees</th>
        <td mat-cell *matCellDef="let row">{{ row.treatmentFeeCount }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row">
          @if (row.isDeleted) {
            <span
              class="inline-flex items-center rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-800"
            >
              Deleted
            </span>
          } @else {
            <span
              class="inline-flex items-center rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800"
            >
              Active
            </span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          @if (row.isDeleted) {
            <button
              mat-icon-button
              color="primary"
              matTooltip="Restore this fee schedule"
              aria-label="Restore this fee schedule"
              [disabled]="restoring() !== undefined"
              (click)="restoreFeeSchedule(row)"
            >
              @if (restoring() === row.feeSchedule.ref.path) {
                <mat-spinner diameter="18" />
              } @else {
                <mat-icon fontSet="material-symbols-outlined"
                  >restore</mat-icon
                >
              }
            </button>
          } @else {
            <button
              mat-icon-button
              color="warn"
              matTooltip="Soft delete this fee schedule"
              aria-label="Delete this fee schedule"
              [disabled]="deleting() !== undefined"
              (click)="deleteFeeSchedule(row)"
            >
              @if (deleting() === row.feeSchedule.ref.path) {
                <mat-spinner diameter="18" />
              } @else {
                <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
              }
            </button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  } @else {
    <div
      class="flex flex-col items-center justify-center px-4 py-8 text-black/[0.38]"
    >
      <mat-icon
        fontSet="material-symbols-outlined"
        class="mb-4 !h-12 !w-12 !text-5xl"
        >event_available</mat-icon
      >
      <p class="m-0 text-sm">
        No practice or staffer fee schedules found for this workspace.
      </p>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" mat-button (click)="close()">Close</button>
</mat-dialog-actions>
